export default __webpack_public_path__ + "static/media/HelpTweet.6db44a8b.svg";